/**
 * cdn-domain-detail-row.tsx — Label/value detail row for the CDN domain overview.
 *
 * Mirrors Partner's OverviewTab.tsx DetailRow: label in muted sm text above,
 * value in lg (or mono md) below. `full` spans both grid columns.
 */

export function CdnDetailRow({
  label,
  children,
  mono = false,
  full = false,
}: {
  label: string;
  children: React.ReactNode;
  mono?: boolean;
  full?: boolean;
}) {
  return (
    <div
      style={{
        display: 'grid',
        gap: 'var(--vn-space-1)',
        gridColumn: full ? '1 / -1' : undefined,
        minWidth: 0,
      }}
    >
      <dt style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)' }}>
        {label}
      </dt>
      <dd
        style={{
          margin: 0,
          fontSize: mono ? 'var(--vn-font-size-md)' : 'var(--vn-font-size-lg)',
          fontFamily: mono ? 'var(--vn-font-mono, ui-monospace, monospace)' : undefined,
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
        }}
      >
        {children ?? '—'}
      </dd>
    </div>
  );
}
